module.exports = __webpack_public_path__ + "static/media/receipt-scan-area-mobile.74ae5364.svg";